import { ICustomSelectProps } from "../../../Components/formComponents";


export const payment_mode_list:ICustomSelectProps["options"] = [
    { label: "Cash", value: "CASH" },
    { label: "Credit Card", value: "CREDIT_CARD" },
    { label: "Interac", value: "INTERAC" },
    { label: "Cheque", value: "CHEQUE" },
  ]